import React, { useEffect } from 'react';
import { PageProps } from '../Page.types';
import Footer from '../../components/Footer/Footer';
import { useAuth0 } from '@auth0/auth0-react';
import HomeAuthed from '../../components/HomeAuthed/HomeAuthed';
import HomePublic from '../../components/HomePublic/HomePublic';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Home: React.FunctionComponent<PageProps> = ({
  layout: Layout,
  navigation: Navigation,
}) => {
  const { isAuthenticated } = useAuth0();

  //TODO: Remove this to enable the authed home page
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (isAuthenticated && !searchParams.get('authed_home')) {
      navigate('/trips');
    }
  }, [isAuthenticated, searchParams]);
  // END TODO BLOCK

  const HomeComponent = isAuthenticated ? HomeAuthed : HomePublic;
  return (
    <Layout
      navigation={<Navigation />}
      footer={<Footer />}
      mobileFullWidth={!isAuthenticated}
    >
      <HomeComponent />
    </Layout>
  );
};

export default Home;
